/**
 * Created by YPF on 20/11/05.
 */

import { getHttpHeader } from '~/common/utils/index.js';
const axios = require('axios')

/** 合法uri*/
export function regexURL(str) {
  let urlRegex = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/g;
  return urlRegex.test(str)
}

/** 判断输入的是IP*/
export function regexIP(str) {
  let regex = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  return regex.test(str)
}

/** 邮箱*/
export function regexEmail(str) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(str)
}

/** 手机*/
export function regexMobile(str) {
  const reg = /^(\+?0?\d{1,4}\s?)?[0-9]{7,11}$/
  return reg.test(str)
}
/** 手机 不带区号*/
export function regexMobileNoArea(str) {
  const reg = /^1[3456789]\d{9}$/
  return reg.test(str)
}
/** 判断输入的是电话*/
export function regexPhone(str) {
  //台湾等，没有区号
  let arr = str.split(" ");
  let regex = /^((\+?0?\d{1,4})?\s?(\d{0,4})\s(\d{6,8}))$/;
  //let regex1 = /^((\+?0?\d{1,4})\s(\d{0,4})\s(\d{6,8})\s(\d{1,6}))$/;韦悦说分机号不加限制
  let regex2 = /\d{6,8}/;
  return regex2.test(str)
  /* if(arr.length>3){
    return regex1.test(str)
  }else{
    return regex.test(str)
  } */
}

/** 判断输入的是微信*/
export function regexWX(str) {
  //暂时放开，不校验
  return true
  // let regex = /^[a-zA-Z][a-zA-Z0-9\_\-]{5,19}$/;
  // return regex.test(str)
}

/** 判断输入的是QQ*/
export function regexQQ(str) {
  let regex = /^[1-9][0-9]{4,15}$/;
  return regex.test(str)
}

/** 判断输入的是0和正整数 */
export function regexIntNumber(nubmer) {
  let regex = /^(0|[1-9][0-9]*)$/;
  return regex.test(nubmer)
}

/** 判断输入的是正数 */
export function regexFloatNumber(nubmer) {
  let regex = /^[0-9]+.?[0-9]*/;
  return regex.test(nubmer)
}
/** 判断输入的是非负数，可以0开头，不限制位数 *///(有bug,-100校验通过)
export function regexLongNumber(nubmer) {
  let regex = /^[1-9]d*|0$/;
  return regex.test(nubmer)
}
/** 判断输入的是正整数 */
export function regexPositiveInteger(nubmer) {
  let regex = /(^[1-9]\d*$)/;
  if (nubmer || isNaN(NaN)) {
    return regex.test(nubmer)
  }
  return true
}
/** 判断输入的是数字*/
export function regexCommonNumber(nubmer) {
  let regex = /^([0-9]+\.?[0-9]*|-[0-9]+\.?[0-9]*)$/;
  return regex.test(nubmer)
}
/** 判断输入的是中英文字母+数字 */
export function regCnAndEnChartAndNum(str) {
  let regex = /^[a-zA-Z0-9\u4e00-\u9fa5\s]+$/;
  if (str) {
    return regex.test(str)
  }
  return true
}
/** 判断输入的是中英文字母 */
export function regCnAndEnChart(str) {
  let regex = /^[a-zA-Z\u4e00-\u9fa5\s]+$/
  if (str) {
    return regex.test(str)
  }
  return true
}
export function bankName(str) {
  let regex = /^[\u4e00-\u9fa5\uff08\uff09a-zA-Z\s!@#$%^&*()_+,.;/]+$/
  if (str) {
    return regex.test(str)
  }
  return true
}
/** 判断输入的是英文字母数字和横杠（斜杠下划线） */
//  /^[A-Za-z0-9-_/]+$/
export function regCnAndEnAndHozBar(str) {
  let regex = /^[A-Za-z0-9-]+$/
  if (str) {
    return regex.test(str)
  }
  return true
}
//判断输入的是英文字母数字
export function regEnAndNum(str) {
  let regex = /^[A-Za-z0-9]+$/
  if (str) {
    return regex.test(str)
  }
  return true
}
/** 判断输入的是英文字母 */
export function regEnChart(str) {
  let regex = /^[0-9a-zA-Z]*$/g
  if (str) {
    return regex.test(str)
  }
  return true
}
/** 判断输入的是数字 数字的整数部分须少于12位，小数部分须少于6位*/
export function regexNumber(nubmer) {
  let regex = /^([-+]?\d{1,12})(\.\d{0,6})?$/;
  return regex.test(nubmer)
}

/** 判断输入的是货币 货币的整数部分须少于14位，小数部分须少于6位*/
export function regexMoneyNumber(nubmer, digits = 6) {
  let regex = eval(`/^([-+]?\\d{1,14})(\\.\\d{0,${digits}})?$/`);
  return regex.test(nubmer)
}

/** 小写字母*/
export function regexLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/** 大写字母*/
export function regexUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/** 大小写字母*/
export function regexAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}
//后端没定义最大值 前端暂时取安全值2^53=9007199254740992 16位
export function checkMaxNum(str) {
  if (str && str > 9007199254740992) {
    return false
  }
  return true
}
/** 英文字符或数字*/
export function checkEnAndNum(str) {
  var reg = /^[0-9a-zA-Z\s]+$/; //英文字母和数字
  var reg1 = /[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]/; //英文符号
  var reg2 = /[\u4e00-\u9fa5]/; //中文
  if (str && !reg.test(str) && !reg1.test(str)) {
    return false
  } else if (str && reg2.test(str)) {
    return false
  } else {
    return true
  }
}
/** 英文字母、数字和空格*/
export function checkEnAndNumAndSpace(str) {
  var reg = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/; //英文字母或数字和空格
  if (str && !reg.test(str)) {
    return false
  } else {
    return true
  }
}
/** IP地址校验*/
export function checkIpAddress(str) {
  // ip正则
  var reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
  return reg.test(str)
}
//校验唯一性
export function checkUnique(str, { compareFiled = "is_exists", ...rule }) {
  if (str && process.client) {
    return new Promise((resolve, reject) => {
      axios.post(rule.api, {
        [rule.name]: str,
        id: rule.id,
        ...rule.param
      }, {
        headers: {
          'X-Session-Token': getHttpHeader()
        }
      }).then(({ data: { data, code } }) => {
        if (code !== 200) return
        if (data[compareFiled] === true) {
          return resolve(false)
        } else {
          return resolve(true)
        }
      }).catch(err => {

      })

    })
  } else {
    return true
  }

}
/** 中英文字符或数字*/
export function checkCnAndEnAndNum(str) {
  var reg = /^[\u4e00-\u9fa5_a-zA-Z0-9\s]+$/; //中英文字母和数字
  var reg1 = /[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]/; //英文符号
  var reg2 = /[\u3002\uff1b\uff0c\uff1a\u201c\u201d\uff08\uff09\u3001\uff1f\u300a\u300b]/; //中文字符
  if (str && !reg.test(str) && !reg1.test(str) && !reg2.test(str)) {
    return false
  } else {
    return true
  }
};

/** 英文字母*/
export function checkEn(str) {
  var reg = /^[a-zA-Z]+$/; //英文字母
  return reg.test(str)
}

/** 计算中英字符长度*/
export function regexStringsLengths(str, min, max) {
  let len = 0;
  for (let i = 0; i < str.length; i++) {
    let zi = str.charAt(i);
    if (zi <= '\u007F') len += 1;
    if (zi > '\u007F' && zi <= '\u07FF') len += 1;
    if (zi > '\u07FF' && zi <= '\uFFFF') len += 2;
  }
  return (len >= min && len <= max)
}
/**字符串至少包含n个数字*/
export function numInStringLength(str, min, max) {
  let len = 0;
  for (let i = 0; i < str.length; i++) {
    let zi = str.charAt(i);
    if (zi >= '\u0030' && zi <= '\u0039') len += 1;
  }
  return (len >= min && len <= max)
}

/**
  联系方式匹配
  @params contactType String 联系方式中文
  callback {
    type    输入框类型
    regFunc 输入框输入规则验证方法
  }
*/
export function contactTypeMatch(contactType) {
  const regFuncs = [{
    name: ['手机'],
    type: 'mobile',
    regFunc: regexMobile,
  }, {
    name: ['座机', '传真', '电话'],
    type: 'phone',
    regFunc: regexPhone,
  }, {
    name: ['平台号'],
    type: 'text',
    regFunc: regEnAndNum,
  }, {
    name: ['IP'],
    type: 'text',
    regFunc: regexIP,
  }, {
    name: ['网址', '网站'],
    type: 'text',
    regFunc: regexURL,
  }, {
    name: ['Email', '邮箱'],
    type: 'text',
    regFunc: regexEmail,
  }, {
    name: ['微信'],
    type: 'text',
    regFunc: regexWX,
  }, {
    name: ['QQ'],
    type: 'text',
    regFunc: regexQQ,
  }];

  return regFuncs.find(({ name }) => name.indexOf(contactType) >= 0);
}
